import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import keyBy from 'lodash-es/keyBy';

import type { Vehicle } from 'vms/features/vehicles/types';

import type { Flag, FlagChanges } from './types';

export interface FlagsState {
  entities: Record<string, Flag>;
  dialogEditData: { vehicle: Vehicle; changes: FlagChanges } | null;
}

export const initialState: FlagsState = {
  entities: {},
  dialogEditData: null,
};

const flagsSlice = createSlice({
  name: 'flags',
  initialState,
  reducers: {
    loadFlagsSuccess(state, action: PayloadAction<Flag[]>) {
      if (action.payload.length === 0) {
        return;
      }
      state.entities = { ...state.entities, ...keyBy(action.payload, 'id') };
    },
    flagEdit(state, action: PayloadAction<{ vehicle: Vehicle; changes: FlagChanges }>) {
      state.dialogEditData = action.payload;
    },
    flagCloseDialogs(state) {
      state.dialogEditData = null;
    },
  },
});

export const { loadFlagsSuccess, flagEdit, flagCloseDialogs } = flagsSlice.actions;

export const reducer = flagsSlice.reducer;

export default flagsSlice;
